import React from 'react'
import { pathOr, equals } from 'ramda'
import { useTranslation } from 'react-i18next'
import { Field } from 'components/Form'
import Switch from '@shared/Form/Switch'

type Props = {
  name: string
  item?: any
}
const ActivateFormField = React.memo(({ item, name, ...props }: Props) => {
  const { t } = useTranslation()

  const activeValue = pathOr(1, [name], item)
  const [isActive, setIsActive] = React.useState(equals(activeValue, 1))

  return (
    <>
      <div className="text-larger mr-8">
        {isActive ? t(`device:active`) : t(`device:inactive`)}
      </div>
      <Field
        {...props}
        name={name}
        getValueFromEvent={val => {
          setIsActive(val)
          return val
        }}
        valuePropName="checked"
        className="w-60"
        initialValue={isActive}>
        <Switch />
      </Field>
    </>
  )
})

export default ActivateFormField
